import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mute: false,
    deutsch: true,
    deaf: false,
    srcpath: true,
    rerender: 0,
    showSubMenu: false,
    noClickValue: false
  },
  mutations: {
    toggleMenu (state, status) {
      this.state.showSubMenu = status
    },
    noClick (state, status) {
      this.state.noClickValue = status
    },
    addUpRerender (state) {
      this.state.rerender++
    },
    changeSrcPath (state, status) {
      this.state.srcpath = status
    }
  },
  actions: {

  }
})
